import { useApi } from '@/shared/api/http';
import type {
  IComplaintData,
  IComplaintResponse,
} from '@/entities/complaint/model/types';

export const useComplaintService = () => {
  const api = useApi();

  const sendComplaint = async (data: IComplaintData) => {
    return await api.post<IComplaintResponse>('complaints', data);
  };

  return {
    sendComplaint,
  };
};
